import { useState, useEffect, createContext } from "react";
import { useDispatch } from "react-redux";
import {
  getCoachesByPatientAPI,
  getUserAppointmentConfigAPI,
  getCoachAppointmentConfigAPI,
  createAppointmentAPI,
  getTopicCategoriesAPI,
  getPatientAppointmentsAPI,
  getOnboardingCoachesByPatientAPI
} from "../../../screens/chats/scheduler-actions/scheduler-api-actions";

const usePatientProfileAppointmentsContext = () => {
  const dispatch = useDispatch();
  const [coachAppointmentConfig, setCoachAppointmentConfig] = useState(null);
  const [gettingCoachAppointmentConfig, setGettingCoachAppointmentConfig] = useState(false);
  const [userAppointmentConfig, setUserAppointmentConfig] = useState([]);
  const [gettingUserAppointmentConfig, setGettingUserAppointmentConfig] = useState(false);
  const [coachesByPatient, setCoachesByPatient] = useState([]);
  const [gettingCoachesByPatient, setGettingCoachesByPatient] = useState(false);
  const [selectedCoach, setSelectedCoach] = useState("");
  const [topicCategories, setTopicCategories] = useState([]);
  const [gettingTopicCategories, setGettingTopicCategories] = useState(false);
  const [ patientAppointments, setPatientAppointments ] = useState([]);
  const [ gettingPatientAppointments, setGettingPatientAppointments ] = useState(false);
  const [ onboardingCoachByPatient, setOnboardingCoachByPatient ] = useState([]);
  const [ gettingOnboardingCoachByPatient, setGettingnboardingCoachesByPatient ] = useState(false);

  useEffect(() => {
    getUserAppointmentConfigAPI(
      dispatch,
      setGettingUserAppointmentConfig,
      setUserAppointmentConfig
    );
    getTopicCategoriesAPI(
      dispatch,
      setGettingTopicCategories,
      setTopicCategories
    );
  }, []);

  useEffect(() => {
    if (selectedCoach) {
      getCoachAppointmentConfigAPI(
        dispatch,
        setGettingCoachAppointmentConfig,
        setCoachAppointmentConfig,
        selectedCoach
      );
    }
  }, [selectedCoach]);

  const createAppointment = async (coachId, start_time, end_time, options) => {
    return await createAppointmentAPI(
      dispatch,
      coachId,
      start_time,
      end_time,
      options
    );
  };

  const getCoachesByPatient = async patientId => {
    await getCoachesByPatientAPI(
      dispatch,
      setGettingCoachesByPatient,
      setCoachesByPatient,
      patientId
    );
  };
  
  const getOnboardingCoachesByPatient = async patientId => {
    await getOnboardingCoachesByPatientAPI(
      dispatch,
      setGettingnboardingCoachesByPatient,
      setOnboardingCoachByPatient,
      patientId
    );
  };

  const getPatientAppointments = async (patientId, topicIds = "") => {
    await getPatientAppointmentsAPI(
      dispatch,
      setGettingPatientAppointments,
      setPatientAppointments,
      patientId,
      topicIds
    );
  }

  return {
    coachAppointmentConfig,
    userAppointmentConfig,
    gettingUserAppointmentConfig,
    gettingCoachAppointmentConfig,
    coachesByPatient,
    gettingCoachesByPatient,
    selectedCoach,
    topicCategories,
    gettingTopicCategories,
    patientAppointments,
    gettingPatientAppointments,
    onboardingCoachByPatient,
    gettingOnboardingCoachByPatient,
    setSelectedCoach,
    createAppointment,
    getCoachesByPatient,
    getOnboardingCoachesByPatient,
    getPatientAppointments
  };
};

export default usePatientProfileAppointmentsContext;

export const AppointmentsContext = createContext();
